<template>
    <div class="recommend-info">
        <div class="info-header">热门推荐</div>
<!--        <div>{{recommendList}}</div>-->
        <grid-view class="grid-view">
<!--            <div>hello</div>-->
            <detail-recommend-good-item v-for="(item,index) in recommendList" :key="index" :goods-item="item">{{item}}</detail-recommend-good-item>
        </grid-view>
    </div>
</template>

<script>
    import GridView from "../../../components/common/gridView/GridView";
    import DetailRecommendGoodItem from "./DetailRecommendGoodItem";
    export default {
        name: "DetailRecommendInfo",
        components: {
            DetailRecommendGoodItem,
            GridView
        },
        props:{
            recommendList:{
                type:Array,
            }
        }
    }
</script>

<style scoped>
    .recommend-info {
        padding: 5px;
    }

    .info-header {
        line-height: 40px;
        padding-left: 8px;
        font-size: 15px;
        color: #333;
    }
    .grid-view{
        width: 100%;
        /*background-color: #d43e2e;*/
    }
</style>